import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { ContentBookPath } from '../../../asset/utils/Constant';
import { setLoading } from '../../../store/CommonSlice';
import { ImageButton } from '../ImageButton';

const BtnWrap = styled.div`
  display: flex;
  grid-column-gap: 15px;
  margin-top: 30px;
  margin-bottom: 400px; 
`;

export const ResourcesButton = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  
  const onFileDownload = (value) => {
    const path = ContentBookPath + (state.book.current_book + 1) + "/Learning_Resources/" + value + '.zip';

    fetch(path, {method : 'GET'}).then((res) => {
      dispatch(setLoading(true));
      return res.blob();
    }).then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');

      a.href = url;
      a.download = value;

      document.body.appendChild(a);
      a.click();

      setTimeout((_) => {
        window.URL.revokeObjectURL(url);
      }, 60000);

      setTimeout(() => {
        dispatch(setLoading(false));
      }, 4000)

      a.remove();
    }).catch((err) => {
      console.error('err : ', err);
    });
  };

  return (
    <BtnWrap>
      <ImageButton 
        type="resource"
        src="https://content.chungchy.com/PhonicsHero/web_resource/images/LearningResources/Answer_Key.png"
        alt="Answer_Key"
        onClick={() => onFileDownload('Answer_Key')}
      />
      <ImageButton 
        type="resource"
        src="https://content.chungchy.com/PhonicsHero/web_resource/images/LearningResources/Flashcard.png"
        alt="Flashcard"
        onClick={() => onFileDownload('Flash_Card')}
      />
      <ImageButton 
        type="resource"
        src="https://content.chungchy.com/PhonicsHero/web_resource/images/LearningResources/Lesson_Plna.png"
        alt="Lesson_Plna"
        onClick={() => onFileDownload('Lesson_Plan')}
      />
      <ImageButton
        type="resource"
        src="https://content.chungchy.com/PhonicsHero/web_resource/images/LearningResources/Mp3_File.png"
        alt="Mp3_File"
        onClick={() => onFileDownload('Mp3_file')}
      />
      <ImageButton 
        type="resource"
        src="https://content.chungchy.com/PhonicsHero/web_resource/images/LearningResources/Syllabus.png"
        alt="Syllabus"
        onClick={() => onFileDownload('Syllabus')}
      />
      <ImageButton 
        type="resource"
        src="https://content.chungchy.com/PhonicsHero/web_resource/images/LearningResources/Test.png"
        alt="Test"
        onClick={() => onFileDownload('Test')}
      />
    </BtnWrap>
  );
};